import { Icon } from "semantic-ui-react";

import React, { useState } from "react";
import { useTranslation } from "react-i18next";

import { db, firebase } from "astrid-firebase";
import createVoiceOffer from "astrid-firestore/src/api/offers/createVoiceOffer";
import { getDocumentData } from "astrid-firestore/src/helpers";

import Flex from "../../../../../components/Flex/Flex";
import { getProfile } from "../../../../authentication/state/profile";
import Accordion from "../../../../ui/components/Accordion/Accordion";

import ReaderSearchForm from "../../ReaderSearchForm/ReaderSearchForm";

export default function AddReaderAction({ voice, production, selectedReaderIds }) {
	const { t } = useTranslation();

	const [open, setOpen] = useState(false);

	return (
		<>
			<Accordion.Title onClick={() => setOpen(true)}>
				<Flex style={{ gap: 12, justifyContent: "flex-start" }}>
					<Icon circular inverted name="plus" color="blue" style={{ margin: 0, fontSize: "1.25em" }} />

					{t("addReader", "Add reader")}
				</Flex>
			</Accordion.Title>

			{open && (
				<ReaderSearchForm
					language={production.language}
					selectedReaderIds={selectedReaderIds}
					onSubmit={async ({ reader }) => {
						const user = await getDocumentData(db.collection("users").doc(reader.id));

						await createVoiceOffer(firebase, {
							production,
							voiceId: voice.id,
							user,
							price: reader?.price,
							createdBy: getProfile(),
						});
					}}
					onClose={() => setOpen(false)}
					submitText={t("addToVoice", "Add to voice")}
				/>
			)}
		</>
	);
}
